'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { EVehicleS } from '@lichtblick/photon/icons/technology/e-vehicle-s';
import { useTracker } from '@lichtblick/tracker';
import { useRef, useState } from 'react';
import { buildUrl } from '../../helpers/links';
import { ChargingUsageInput } from './ChargingUsageInput';
import { CityInput } from './CityInput';
import { CalculatorLayout } from './calculator-layout';
import styles from './calculator-layout.module.scss';
import { carUsage, ELECTRICITY_USAGE, mileageLimit, PEOPLE_LIMIT, usageLimitElectricity } from './constants';
import { ElectrictyUsageInput } from './ElectricityUsageInput';
import { CalculatorTranslations } from './translations';
import { UsageModal } from './UsageModal';
import { useVpCodes } from './useVpCodes';
export const HomeChargingCalculator = ({ _uid, checkoutUrl, chip, directSalesPartnerCode, headline, isActionTriggerDisabled, powerCloudCampaignId, useDirectSalesPartnerCodeSitewide })=>{
    const { computeVpCodes } = useVpCodes();
    const { trackCustomEvent } = useTracker();
    const peopleUsageRef = useRef(null);
    const distanceUsageRef = useRef(null);
    const [isElectricityUsageModalOpen, setIsElectricityUsageModalOpen] = useState(false);
    const [values, setValues] = useState({
        carUsage: String(carUsage.default),
        peopleCount: PEOPLE_LIMIT.min,
        mileage: mileageLimit.default,
        electricityUsage: String(ELECTRICITY_USAGE[0])
    });
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (peopleUsageRef.current && Number(peopleUsageRef.current.value) > usageLimitElectricity.max) {
            setIsElectricityUsageModalOpen(true);
            return;
        }
        if (distanceUsageRef.current && Number(distanceUsageRef.current.value) > usageLimitElectricity.max) {
            setIsElectricityUsageModalOpen(true);
            return;
        }
        trackCustomEvent({
            eventName: 'tariff_calculator_show_tariffs',
            customProps: {
                product: 'ZuHause Plus',
                people_counter: values?.peopleCount,
                kilometers_traveled: `${values?.mileage} km/Jahr`,
                consumption_calculator: `${values?.electricityUsage} kWh/Jahr;${values?.carUsage} kWh/Jahr`,
                zip_code: values?.postcode
            }
        });
        const vpCodes = computeVpCodes(directSalesPartnerCode, useDirectSalesPartnerCodeSitewide);
        const electricityUsage = values?.electricityUsage ? Number(values.electricityUsage) : 0;
        const carUsage = values?.carUsage ? Number(values.carUsage) : 0;
        const totalUsage = electricityUsage + carUsage;
        const params = new URLSearchParams({
            ...values?.city && {
                ort: values.city
            },
            ...values?.postcode && {
                plz: values.postcode
            },
            ...totalUsage && {
                strom: totalUsage.toString()
            },
            ...powerCloudCampaignId && {
                cam: powerCloudCampaignId
            },
            ...vpCodes?.vp && {
                vp: vpCodes.vp
            },
            ...vpCodes?.uvp && {
                uvp: vpCodes.uvp
            }
        });
        location.assign(`${buildUrl(checkoutUrl) ?? '/checkout/'}?${params.toString()}`);
    };
    return /*#__PURE__*/ _jsx(CalculatorLayout, {
        chip: chip,
        headerColor: "LightMoss",
        headline: headline,
        icon: /*#__PURE__*/ _jsx(EVehicleS, {}),
        id: _uid,
        isActionTriggerDisabled: isActionTriggerDisabled,
        children: /*#__PURE__*/ _jsxs("form", {
            className: styles['calculator-content'],
            method: "get",
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles['calculator-input-row'],
                    children: [
                        /*#__PURE__*/ _jsx(ElectrictyUsageInput, {
                            onChange: (value, peopleCount)=>setValues((prev)=>({
                                        ...prev,
                                        electricityUsage: value,
                                        peopleCount: peopleCount
                                    })),
                            usageRef: peopleUsageRef,
                            children: /*#__PURE__*/ _jsx(UsageModal, {
                                isOpen: isElectricityUsageModalOpen,
                                route: "/gewerbestrom",
                                setIsOpen: setIsElectricityUsageModalOpen
                            })
                        }),
                        /*#__PURE__*/ _jsx(ChargingUsageInput, {
                            onChange: (value, mileage)=>setValues((prev)=>({
                                        ...prev,
                                        carUsage: value,
                                        mileage: mileage
                                    })),
                            usageRef: distanceUsageRef
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(CityInput, {
                    onChange: (city, postcode)=>{
                        setValues((prev)=>({
                                ...prev,
                                city: city,
                                postcode: postcode
                            }));
                    }
                }),
                /*#__PURE__*/ _jsx(BoxCTA, {
                    as: "button",
                    "data-testid": "calc-submit",
                    type: "submit",
                    wide: true,
                    children: CalculatorTranslations.submitLabel
                })
            ]
        })
    });
};

//# sourceMappingURL=HomeChargingCalculator.js.map